enum ResourceTypes {
  VIRTUAL = "VIRTUAL",
  HUMAN = "HUMAN",
  MATERIAL = "MATERIAL",
}

export { ResourceTypes };
